import { render, staticRenderFns } from "./PortfolioTotalsRow.vue?vue&type=template&id=d3dc540a&"
import script from "./PortfolioTotalsRow.vue?vue&type=script&lang=js&"
export * from "./PortfolioTotalsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports